module.exports = __webpack_public_path__ + "img/DE02315.cf0ac77c.png";